export default __webpack_public_path__ + "static/media/agent3.a6e7c138.png";